export const useOS = () => {
  const u = navigator.userAgent
  const isIOS = !!u.match(/iPad|iPhone/i)

  const isAndroid = !!u.match(/Android/i)

  const isOther = !isIOS && !isAndroid

  return { isIOS, isAndroid, isOther }
}
